import { ReducerAction, ReducerState } from 'react'

type ReduxDevTools = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  send: (action: ReducerAction<any>, state: ReducerState<any>, options?: { name: string }) => void
  connect: (options: { name: string }) => ReduxDevTools
}
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__: ReduxDevTools | undefined
  }
}
export const getDevTools = () => {
  return typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ != null
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : undefined
}

export const createDevToolsInstance = (name: string) => {
  return typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ != null
    ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({ name })
    : undefined
}
